import type { PointSnappingSettings, PointSnapToggleKey } from '../../layout-snapping/point-snapping/settings';

const WORK_LINE_IGNORED_ENTITY_SNAPS = [
  'nearestPoint',
  'perpendicularProjection',
] as const satisfies readonly (keyof PointSnappingSettings['entitySnaps'])[];

const WORK_LINE_IGNORED_SEGMENT_SNAPS = [
  'orthogonal',
  'angle',
  'lengthIncrement',
] as const satisfies readonly (keyof PointSnappingSettings['segmentSnaps'])[];

export const WORK_LINE_IGNORED_POINT_SNAPS = [
  ...WORK_LINE_IGNORED_ENTITY_SNAPS,
  ...WORK_LINE_IGNORED_SEGMENT_SNAPS,
] as const satisfies readonly PointSnapToggleKey[];

export function restrictPointSnappingSettingsForWorkLineInsertion(
  settings: PointSnappingSettings,
): PointSnappingSettings {
  const entitySnaps = { ...settings.entitySnaps };
  for (const key of WORK_LINE_IGNORED_ENTITY_SNAPS) entitySnaps[key] = false;

  const segmentSnaps = { ...settings.segmentSnaps };
  for (const key of WORK_LINE_IGNORED_SEGMENT_SNAPS) segmentSnaps[key] = false;

  return { ...settings, entitySnaps, segmentSnaps };
}
